import { createConsumer } from '@rails/actioncable'
const packageJson = require('../../../../config/cable.json')
const URL = packageJson.url
const consumer = createConsumer(URL)

export default consumer
